class OhsBiPermissions {
  view: boolean;

  constructor(flag: boolean) {
    this.view = flag;
  }
}

export default OhsBiPermissions;
